export class LookupValueQuery {
    public static VesselTypes:string = "RS_VesselTypes"
    public static IncidentZones: string = "RS_IncidentZones"
    public static VesselStatuses: string = "RS_VesselStatuses"
    public static VesselStatusGroups: string = "RS_VesselStatusGroups"
    public static FbrStatuses: string = "RS_FbrStatuses"
    public static CfrStatuses: string = "RS_CfrStatuses"
    public static Countries: string = "RS_Countries"
    public static Customers: string = "RS_Customers"
    public static IncidentEventInitialCauses: string = "RS_IncidentEventInitialCauses"
    public static IncidentEventActions: string = "RS_IncidentEventActions"
    public static IncidentEventComponents: string = "RS_IncidentEventComponents"
    public static IncidentEventPositions: string = "RS_IncidentEventPositions"
    public static BusinessUnits: string = "RS_BusinessUnits"
    public static CasualtyTypes: string = "RS_CasualtyTypes"
    public static RuleCategories: string = "RS_RuleCategories"
    public static RiskCategories: string = "RS_RiskCategories"
    public static ThirdPartyDataSources: string = "RS_ThirdPartyDataSources"
    public static ThirdPartyDataTypes: string = "RS_ThirdPartyDataTypes"
    public static OcimfDataTypes: string = "RS_OcimfDataTypes"
    public static RuleSeverities: string = "RS_RuleSeverities"
    public static VetStatuses: string = "RS_VetStatuses"
    public static VetCancellationStatusReasons: string = "RS_VetCancellationStatusReasons"
    public static VoyageDataSubmissionStatuses: string = "RS_VoyageDataSubmissionStatuses"
    public static SafetyRatingReviewStatuses: string = "RS_SafetyRatingReviewStatuses"
    public static PscInspectionStatuses: string = "RS_PscInspectionStatuses"
    public static RightShipInspectionStatuses: string = "RS_RightShipInspectionStatuses"
    public static GhgVerificationStatuses: string = "RS_GhgVerificationStatuses"
    public static IncidentStatuses: string = "RS_IncidentStatuses"
    public static SubtaskStatuses: string = "RS_SubtaskStatuses"
    public static RuleConfigParameters: string = "RS_RuleConfigParameters"
    public static ListAlertTypes: string = "RS_ListAlertTypes"
    public static Users: string = "Users"
    public static WorkflowStatuses: string = "WorkflowStatuses";
    public static IncidentMisreportedReasons: string = "RS_IncidentMisreportedReasons"
    public static PscInspectionMisreportedReasons: string = "RS_PscInspectionMisreportedReasons"
    public static ComputedIncidentSeverities: string = "RS_ComputedIncidentSeverities"
    public static OnboardingConfigs: string = "OnboardingConfigs"
    public static ListGroups: string = "RS_ListGroups"
    public static SubtaskTypes: string = "RS_SubtaskTypes"
    public static InspectionStates: string = "RS_InspectionStates"
    public static EntityTypes: string = "EntityTypes"
    public static RsPscAuthorities:string= "RS_PscAuthorities";
    public static Flags: string = "Flags";
    public static ClassificationSocieties: string = "ClassificationSocieties";
    public static RuleActions: string = "Rs_RuleActions";
    public static RuleCollectionUIListTemplates: string = "RS_RuleCollectionUIListTemplates";
    public static CurrencyConversionRates: string = "RS_CurrencyConversionRates";
}